<template>
  <section v-if="bonExpedition">
    <header class="border-entete">
      <div class="level">
        <div class="level-left is-justify-content-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3"> {{ $t('editBonExpedition.title') }} </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a class="button btn-modal-annuler" @click="$router.go(-1)">
              {{ $t('general.button.cancel') }}
            </a>
            <a
              class="button is-addOrEdit mgl-10px"
              @click="checkPermissions(constantes.BON_EXPEDITION.maj)
                ? addOrUpdateBonExpedition() : showPopUp()">
              {{ $t('general.button.sauvegarder') }}
            </a>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.BON_EXPEDITION.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </header>
    <div class="mgt-20px">
      <error-msg-component
        :messages="messages"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :error="error"
        :withEmplyFields="true"
        @close="error = $event"
        title="general.problemOccurred"/>
    </div>
    <informations-generales :bonExpedition="bonExpedition"/>
    <section class="card mgt-20px">
      <header class="header-card">
        <p> {{ $t('piecesJointes.attachments')}} </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes
          :checkPermissions="checkPermissions(constantes.BON_EXPEDITION.maj)"
          readOnly deletable autoSave/>
      </div>
    </section>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { get, update } from '@/api/logistique/bonExpedition';
import breadcrumb from '@/components/general/breadcrumb';
import PiecesJointes from '@/components/general/piecesJointes';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import informationsGenerales from '@/components/logistique/bonExpedition/edit/informationsGenerales';
import messageErreur from '@/services/general/messageErreur';
import formatDateIso from '@/services/general/formatIsoDate';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/ordreTravail/expedition/translatorChangerEtatExpedition';
import { BON_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');

export default {
  data() {
    return {
      bonExpedition: null,
      constantes: {
        BON_EXPEDITION,
      },
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      ordreTravails: [],
      error: false,
    };
  },
  components: {
    breadcrumb,
    pieceJointeButton,
    errorMsgComponent,
    informationsGenerales,
    appPiecesJointes: PiecesJointes,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editBonExpedition.breadcrumb.liste'), route: { name: 'l.logistique.bon_expedition' }, isActive: false },
        { title: this.$t('editBonExpedition.breadcrumb.edit'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    async addOrUpdateBonExpedition() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      try {
        const payload = cloneDeep(this.bonExpedition);
        payload.dateBonExpedition = formatDateIso(payload.dateBonExpedition);
        await update(payload);
        await this.$router.push({
          params: { id: payload.id },
          name: 'c.logistique.bon_expedition',
        });
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'BonExpedition' });
      const bonExpedition = (await get(this.$route.params.id)).data.result;
      bonExpedition.dateBonExpedition = new Date(bonExpedition.dateBonExpedition);
      this.bonExpedition = bonExpedition;
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.setInformationPage(this.$t('pageLogistique.ot.editBonExpedition'));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};

</script>
